
/* JWT */
import { isExpired } from "react-jwt"

/* Toast show finction */
import { toast } from 'react-toastify'

/* Moment */
import moment from 'moment'

/* Fields */
const weekdays = [
    { name: "sunday", text: "Вс" },
    { name: "monday", text: "Пн" },
    { name: "tuesday", text: "Вт" },
    { name: "wednesday", text: "Ср" },
    { name: "thursday", text: "Чт" },
    { name: "friday", text: "Пт" },
    { name: "saturday", text: "Сб" }
]



/* Check Token */
export const checkToken = token => {

    if (token === null || token === undefined || token === "" || isExpired(token)) {
        return false
    }

    return true
}

/* Check empty */
export const isEmpty = value => {

    if (value === null || value === undefined || value === "" || value === 0) {
        return false
    }

    return true
}

/* Check value */
export const checkValue = (value, defaultValue = "") => {

    if (value === null || value === undefined || value === "") {
        return defaultValue
    }

    return value
}

/* Calculrate Distance */
export const distance = (distance = 0) => {

    if (distance === null || distance === undefined || distance === "" || distance === 0) {
        return ""
    }

    if (distance > 1000) {
        const km = distance / 1000
        return " • " + km.toFixed(1) + " км"
    }

    return " • " + distance.toFixed(0) + " м"
}

/* PRICE CONVERTOR */
export const convertor = price => {

    /* Check the price for the void */
    if (price === null || price === undefined)
        return ""

    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "\xa0₸"
}

/* TIME CONVERTOR */
export const timeConvertor = minutes => {

    /* Check the price for the void */
    if (minutes === null || minutes === undefined)
        return ""

    const hours = Math.floor(minutes / 60)
    const remain = minutes % 60

    let hour = ""
    let minute = ""

    if (hours > 0) {

        if (hours === 1)
            hour = `${hours} час `

        if (hours > 1 && hours <= 4)
            hour = `${hours} часа `

        if (hours > 4)
            hour = `${hours} часов `
    }

    if (remain > 0) {
        minute = `${parseInt(remain)} минут`
    }

    return `${hour}${minute}`
}





/* GET DAYS LIST OF NEXT WEEK */
export const weekDays = (worktimes, sessionTime) => {

    if ((Array.isArray(worktimes) && worktimes.length > 0) && sessionTime) {

        const getNextDay = index => {
            const today = new Date()
            today.setHours(0)
            today.setMinutes(0)
            today.setSeconds(0)
            today.toLocaleString('ru', { timeZone: 'Asia/Almaty' })
            today.setDate(today.getDate() + index)
            return today
        }

        const getNextWeek = () => [...Array(14).keys()].map(getNextDay)

        let nextWeek = []

        getNextWeek().forEach((date, index) => {

            const weekday = weekdays[date.getDay()].name
            const i = worktimes.findIndex(e => e.day === weekday && parseInt(e.isDayOff) === 0)

            if (i > -1) {

                const day = {
                    number: date.toLocaleDateString('ru', { day: 'numeric' }),
                    isToday: index === 0,
                    date: moment(date).format('YYYY-MM-DD HH:mm:ss'),
                    weekday: weekdays[date.getDay()],
                    day: date.toLocaleDateString('ru', { day: '2-digit' }),
                    month: date.toLocaleDateString('ru', { month: 'short' }),
                    startTime: worktimes[i].startworktime,
                    endTime: worktimes[i].endworktime
                }

                const list = times(worktimes[i].startworktime, worktimes[i].endworktime, sessionTime, day)

                if (list.length > 0) {
                    nextWeek.push(day)
                }

            }
        })

        return nextWeek
    }

    return []
}




/* GET TIMES OF DAY */
export const times = (startTime, endTime, sessionTime, day) => {

    if (!startTime || !endTime || !sessionTime || !day) {
        return []
    }

    let currentNumber = 0

    if (day.isToday) {

        const date = new Date()
        const currentHour = date.getHours()
        const currentMinute = date.getMinutes()

        currentNumber = currentHour * 60

        if (parseInt(sessionTime) > 0) {
            currentNumber = currentNumber + (Math.floor(currentMinute / parseInt(sessionTime)) + 1) * parseInt(sessionTime)
        }
    }

    const getTime = number => {
        const hh = Math.floor(number / 60)
        const hour = hh >= 10 ? hh === 24 ? `00` : hh : `0${hh}`
        const mm = number % 60
        const minute = mm >= 10 ? mm : `0${mm}`
        return `${hour}:${minute}`
    }

    let startNumber = 0
    let endNumber = 24 * 60

    const startTimeList = startTime.split(":")

    if (startTimeList.length > 1) {
        const startHour = parseInt(startTimeList[0])
        const startMinute = parseInt(startTimeList[1])
        startNumber = startHour * 60 + startMinute

        if (startNumber < currentNumber) {
            startNumber = currentNumber
        }
    }

    const endTimeList = endTime.split(":")

    if (endTimeList.length > 1) {
        const endHour = parseInt(endTimeList[0])
        const endMinute = parseInt(endTimeList[1])
        endNumber = endHour * 60 + endMinute

        if (endNumber > parseInt(sessionTime)) {
            endNumber = endNumber - parseInt(sessionTime)
        }
    }

    let times = []
    let time = startNumber

    for (let i = 0; time <= endNumber; i++) {
        const startTime = getTime(time)
        const endTime = getTime(time + parseInt(sessionTime))
        times.push({ startTime, endTime })
        time = time + parseInt(sessionTime)
    }

    return times
}




export const checkTime = (day, time, bookings) => {

    const timeList = time.split(":")

    let startHour = 0
    let startMinute = 0

    if (timeList.length > 1) {
        startHour = parseInt(timeList[0])
        startMinute = parseInt(timeList[1])
    }

    const current = new Date(day.date)
    current.setHours(startHour)
    current.setMinutes(startMinute)

    let status = false

    if (Array.isArray(bookings) && bookings.length > 0) {
        bookings.forEach(item => {

            const startReservedDate = new Date(item.reservedTime)
            const endReservedDate = new Date(item.reservedTime)
            const endMinutes = endReservedDate.getMinutes()
            endReservedDate.setMinutes(endMinutes + parseInt(item.sessionTime))

            const reservedTime = moment(startReservedDate).format('YYYY-MM-DD HH:mm:ss')
            const endReservedTime = moment(endReservedDate).format('YYYY-MM-DD HH:mm:ss')

            if (moment(current).isSameOrAfter(reservedTime) && moment(current).isBefore(endReservedTime)) {
                status = true
            }
        })
    }

    return status
}


/* Toasts */
export const toggleError = (text, icon = "error", toastId) => {

    let data = {
        position: "top-center",
        autoClose: 2500,
        hideProgressBar: false,
        closeButton: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark"
    }

    if (toastId) {
        data.toastId = toastId
    }

    if (icon === "warning" || icon === "success") {
        data.autoClose = 5000
    }

    if (icon === "success") {
        toast.success(text, data)
    }

    if (icon === "warning") {
        toast.warn(text, data)
    }

    if (icon === 'error') {
        toast.error(text, data)
    }

}






/* DEVICE DETECTOR */
export const device = userAgent => {

    if (!userAgent) {
        return { type: "", os: "" }
    }

    let type = (/mobile/i.test(userAgent)) ? "mobile" : "desktop"
    let os = ""

    if (/iPhone/.test(userAgent) || /iPad/.test(userAgent))
        os = "ios"

    if (/Android/.test(userAgent))
        os = "android"

    if (/(Intel|PPC) Mac OS X/.test(userAgent))
        os = "mac"

    return { type, os }
}